import datetime, { getDayMonth, getShortTime } from 'utils/i18n/datetime';

export const createDisplayDateTimeAndPerform = ({ scheduledAt, duration }) => {
  const startTime = datetime(scheduledAt);
  let str = `${getDayMonth(startTime)}, ${getShortTime(startTime)}`;

  if (duration > 0) {
    const endTime = datetime(scheduledAt).add(duration, 'ms');
    str = `${str} - ${getShortTime(endTime)}`;
  }

  return str;
};
